// extracted by mini-css-extract-plugin
export default {"curatedCards":"curatedCards--j3QBn"};